import { ParamValue } from './types/index';

interface DataLayerVariable {
    [key: string]: unknown;
}

export const convertValueToString = (value: ParamValue): string | string[] | undefined => {
    if (value === null || value === undefined) {
        return undefined;
    }
    if (Array.isArray(value)) {
        return value.map((v) => String(v));
    }
    return String(value);
};

export function throttleSearch<T extends (...args: unknown[]) => void>(
    callback: T,
    delay: number,
): (...args: Parameters<T>) => void {
    let timeoutId: number | null = null;

    return (...args: Parameters<T>): void => {
        if (timeoutId) return;
        timeoutId = window.setTimeout(() => {
            callback(...args);
            timeoutId = null;
        }, delay);
    };
}

export const pushToDataLayer = <T extends DataLayerVariable>(variables: T) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ...variables });
};
